import i18n from "i18next"
import { initReactI18next } from "react-i18next"

const resources = {
  id: {
    translation: {
      nav: {
        home: "Beranda",
        mastery: "Penguasaan",
        path: "Jalur",
        account: "Akun",
        billing: "Pembayaran",
        support: "Dukungan",
        feedback: "Masukan",
        analytics: "Analitik",
        more: "Lainnya",
      },
      a11y: {
        skipToContent: "Lewati ke konten",
        homeLabel: "Beranda TutorLite",
        guardianAccountHome: "Beranda akun wali TutorLite",
        primaryNavigation: "Navigasi utama",
        learningNavigation: "Navigasi belajar",
        accountNavigation: "Navigasi akun",
        openAccountMenu: "Buka menu akun untuk {{name}}",
      },
      states: {
        loading: "Memuat halaman",
        errorTitle: "Data belum dapat dimuat",
        errorBody: "Coba lagi. Jika masalah berlanjut, kembali beberapa saat lagi.",
      },
      accountUtility: {
        loadingSession: "Memeriksa sesi akun",
      },
      access: {
        account_restricted: {
          title: "Akses belajar dibatasi",
          body: "Buka akun untuk melihat tindakan keamanan dan akses yang masih tersedia.",
          action: "Buka akun",
        },
        enrollment_required: {
          title: "Selesaikan profil belajarmu",
          body: "Tinjau kebijakan dan selesaikan pendaftaran sebelum membuka materi belajar.",
          action: "Lanjutkan penyiapan",
        },
        guardian_required: {
          title: "Persetujuan wali diperlukan",
          body: "Pembelajaran akan terbuka setelah wali meninjau dan memberikan persetujuan yang diperlukan.",
          action: "Lihat status akun",
        },
        terms_acceptance_required: {
          title: "Tinjau ketentuan terbaru",
          body: "Terima versi ketentuan saat ini sebelum melanjutkan aktivitas belajar.",
          action: "Tinjau ketentuan",
        },
        progress_disabled: {
          title: "Kemajuan tidak tersedia",
          body: "Pelacakan kemajuan tidak tersedia untuk akun ini saat ini.",
        },
        recommendations_disabled: {
          title: "Rekomendasi tidak tersedia",
          body: "Jalur rekomendasi tidak tersedia untuk akun ini saat ini.",
        },
      },
      common: {
        active: "Aktif",
        available: "Tersedia",
        notRequired: "Tidak diperlukan",
        pending: "Menunggu",
        save: "Simpan perubahan",
        saving: "Menyimpan…",
        unavailable: "Tidak tersedia",
      },
      accountSections: {
        profile: "Profil",
        enrollment: "Pendaftaran",
        language: "Bahasa",
        languageDescription: "Pilih bahasa antarmuka TutorLite.",
        languageHint: "Bahasa hanya berubah setelah disimpan.",
        languageSaved: "Bahasa tersimpan.",
        languageError: "Bahasa belum dapat disimpan. Coba lagi.",
        clientsDescription: "Aplikasi pendamping yang diberi akses ke akunmu.",
        revokeError: "Akses aplikasi belum dapat dicabut. Coba lagi.",
        moreClients: "Tampilkan aplikasi lainnya",
        loadingMoreClients: "Memuat aplikasi…",
        session: "Sesi",
        sessionDescription: "Keluar dari TutorLite pada perangkat ini.",
        signingOut: "Keluar…",
        signOutError: "Belum dapat keluar. Coba lagi.",
        guardianSection: "Wali dan persetujuan",
        guardianDescription:
          "Hubungan wali, tujuan persetujuan, dan ringkasan terbatas yang diizinkan.",
        noGuardian: "Belum ada hubungan wali untuk akun ini.",
        guardianRevokeError: "Tujuan persetujuan belum dapat dicabut. Coba lagi.",
        revokePurpose: "Cabut",
        loginMethods: "Metode masuk",
        loginMethodsDescription: "Login yang dapat digunakan untuk membuka akun TutorLite ini.",
        noLoginMethods: "Belum ada metode masuk yang dapat ditampilkan.",
        providerKind: { password: "Kata sandi", oauth: "OAuth" },
        lastLoginMethod: "metode terakhir",
        unlinkProvider: "Putuskan",
        linkProvider: "Hubungkan {{provider}}",
        providerLinkStarting: "Membuka Google…",
        providerLinkPending: "Proses penghubungan {{provider}} masih menunggu.",
        providerLinkSupport: "Minta bantuan untuk percobaan {{attemptId}}",
        providerLinkLearningWarning: "Riwayat belajar dari akun lain tidak dipindahkan.",
        providerLinkBillingWarning: "Riwayat pembayaran dan nilai berbayar tidak dipindahkan.",
        providerLinkError: "Metode masuk belum dapat dihubungkan. Coba lagi.",
        providerUnlinkError: "Metode masuk belum dapat diputus. Coba lagi.",
        providerLinkStatus: {
          pending: "Penghubungan masih menunggu.",
          confirmed: "Metode masuk berhasil dihubungkan.",
          rejected: "Penghubungan ditolak.",
          manual_support_required: "Penghubungan ini perlu ditinjau dukungan.",
          expired: "Percobaan penghubungan telah kedaluwarsa.",
        },
        summaryError: "Ringkasan wali belum dapat dimuat.",
        summaryInteractions: "Interaksi periode ini",
        summaryNextTopic: "Topik berikutnya",
        summaryLastActivity: "Aktivitas terakhir",
        guardianRole: { learner: "Profil pelajar", guardian: "Profil wali" },
        guardianStatus: {
          invited: "Undangan terkirim",
          verified: "Terverifikasi",
          revoked: "Dicabut",
        },
        consentStatus: { active: "Aktif", superseded: "Perlu ditinjau ulang", revoked: "Dicabut" },
        requestGuardianReview: "Minta peninjauan baru",
        optionalLearnerTitle: "Belajar dengan akun ini",
        optionalLearnerDescription:
          "Opsional: aktifkan profil belajar milikmu sendiri. Ini terpisah dari pelajar yang kamu wali.",
        optionalLearnerAction: "Siapkan profil belajarku",
        exportTitle: "Ekspor akun",
        exportDescription:
          "Unduh data akun dalam NDJSON. Rahasia, token, payload provider, dan data pengguna lain tidak disertakan.",
        exportIdle: "Ekspor membutuhkan sesi masuk yang baru dan dibuat langsung saat diunduh.",
        exportPreparing: "Menyiapkan ekspor…",
        exportProgress: "Mengunduh {{bytes}} byte…",
        exportSuccess: "Ekspor siap diunduh ({{bytes}} byte).",
        exportAborted: "Ekspor dibatalkan.",
        exportFreshRequired: "Masuk ulang lalu coba ekspor lagi.",
        exportError: "Ekspor belum dapat dibuat. Coba lagi.",
        exportAction: "Unduh ekspor akun",
        exportAbort: "Batalkan ekspor",
        deleteTitle: "Hapus akun",
        deleteDescription:
          "Tinjau ekspor terlebih dahulu. Permintaan akan menonaktifkan akses belajar dan grant MCP segera, lalu masuk masa tunggu 7 hari.",
        deleteValueFacts: "Nilai aktif/terjadwal: {{passes}} pass, {{credits}} kredit tersisa.",
        deleteNoBlockers: "Tidak ada blocker eksekusi yang terlihat untuk akun ini.",
        deleteStatus: "Status penghapusan: {{status}}.",
        deleteNoRestorePromise:
          "Pembatalan tidak memulihkan sesi, grant MCP, data yang sudah dihapus, atau menambah masa berlaku entitlement.",
        deleteCancel: "Batalkan permintaan penghapusan",
        deleteCancelling: "Membatalkan…",
        deleteCancelError: "Permintaan penghapusan belum dapat dibatalkan.",
        deleteValueDisposition: "Keputusan nilai berbayar yang tersisa",
        deleteDispositionPlaceholder: "Pilih jika ada nilai tersisa",
        deleteDispositionHint:
          "Wajib jika preview menunjukkan pass atau kredit tersisa. Refund review dan forfeiture adalah default teknis staging.",
        deleteRefundReview: "Minta tinjauan refund",
        deleteForfeit: "Lanjut tanpa memakai sisa nilai",
        deleteAcknowledge:
          "Saya sudah mempertimbangkan ekspor dan memahami akses produk langsung dinonaktifkan.",
        deleteTyped: "Ketik DELETE untuk mengonfirmasi",
        deleteTypedHint: "Gunakan huruf besar: DELETE.",
        deleteRequest: "Minta penghapusan akun",
        deleteRequesting: "Mengirim permintaan…",
        deleteRequested:
          "Permintaan diterima. Sesi dan grant tidak dijanjikan pulih otomatis jika dibatalkan.",
        deleteErrors: {
          stale_preview: "Preview sudah berubah. Muat ulang preview lalu coba lagi.",
          fresh_session_required: "Masuk ulang lalu coba lagi.",
          request_blocked: "Permintaan belum dapat diterima karena blocker preview.",
          executor_not_ready: "Executor penghapusan belum siap untuk akun ini.",
          value_disposition_required: "Pilih keputusan nilai berbayar yang tersisa.",
          default: "Permintaan penghapusan belum dapat dibuat.",
        },
        deleteProofTitle: "Akses status jika tidak bisa masuk",
        deleteProofDescription:
          "Gunakan challenge email untuk membaca status atau membatalkan permintaan yang cocok. Token bukti tidak diletakkan di URL.",
        deleteProofSend: "Kirim challenge status",
        deleteProofToken: "Token challenge",
        deleteProofVerify: "Verifikasi challenge",
        deleteProofReady: "Bukti status siap untuk pembacaan atau pembatalan.",
      },
      home: {
        recentEyebrow: "Aktivitas",
        recentTitle: "Belajar terbaru",
        recentLoading: "Memuat aktivitas terbaru",
        recentEmptyTitle: "Belum ada aktivitas belajar",
        recentEmptyBody:
          "Aktivitas aman akan muncul setelah kamu belajar melalui pendamping TutorLite.",
        recentCardTitle: "Perjalanan terakhirmu",
        recentCardDescription: "Aktivitas akun tanpa jawaban, pencarian, atau isi pribadi.",
        loadingEarlier: "Memuat aktivitas sebelumnya…",
        earlierError: "Aktivitas sebelumnya belum dapat dimuat.",
        showEarlier: "Tampilkan aktivitas sebelumnya",
        summaryTitle: "Ringkasan periode ini",
        summaryDescription: "Hitungan singkat; Analitik memiliki rincian sebaran penguasaan.",
        noTopicsBody: "Topik dan langkah berikutnya akan muncul saat profil belajarmu siap.",
      },
      billing: {
        loading: "Memuat pembayaran",
        loadingStatus: "Memuat kuota dan akses",
        loadingCatalog: "Memuat pilihan prabayar",
        loadingHistory: "Memuat riwayat pembayaran",
        description: "Kelola kuota, akses prabayar, kredit, dan riwayat pembayaranmu.",
        returnTitle: "Memeriksa status pembayaran",
        returnBody:
          "Kami sedang membaca status terbaru dari TutorLite. Kembalinya browser ke halaman ini tidak berarti pembayaran telah berhasil.",
        usageTitle: "Akses dan penggunaan",
        usageDescription: "Kuota saat ini dan nilai prabayar yang masih dapat digunakan.",
        freeQuota: "Sisa kuota gratis",
        currentUsage: "Sisa periode saat ini",
        quotaUsed: "{{used}} dari {{limit}} digunakan",
        usageProgress: "{{used}} dari {{limit}} interaksi digunakan",
        usageSource: "Sumber: {{source}}",
        source: { free: "kuota gratis", entitlement: "pass aktif" },
        entitlement: {
          active: "Pass aktif",
          scheduled: "Pass terjadwal",
          activeEmpty: "Belum ada pass aktif.",
          scheduledEmpty: "Belum ada pass berikutnya yang terjadwal.",
        },
        noPass: "Tidak ada",
        term: "Masa berlaku",
        monthlyQuota: "Kuota bulanan",
        creditsTitle: "Lot kredit",
        creditsDescription: "Setiap lot digunakan menurut tanggal kedaluwarsanya.",
        creditRemaining: "dari {{original}} interaksi awal",
        expires: "Kedaluwarsa {{date}}",
        creditsEmpty: "Belum ada kredit prabayar yang tersisa.",
        latestCheckout: "Checkout terbaru",
        checkoutExpires: "Sesi berakhir {{date}}",
        resumeCheckout: "Lanjutkan checkout",
        checkoutStatus: {
          creating: "Membuat checkout",
          reconciling: "Mencocokkan status",
          provider_created: "Siap dibayar",
          pending: "Pembayaran menunggu",
          paid: "Dibayar",
          paid_capacity_conflict: "Dibayar, perlu bantuan",
          expired: "Kedaluwarsa",
          failed: "Gagal",
          cancelled: "Dibatalkan",
        },
        checkoutStatusBody: {
          creating: "TutorLite sedang menyiapkan sesi pembayaran.",
          reconciling: "Status checkout sedang dicocokkan. Jangan membuat pembayaran lain.",
          provider_created: "Sesi pembayaran telah dibuat dan belum dikonfirmasi sebagai dibayar.",
          pending: "Pembayaran belum dikonfirmasi. Halaman ini akan memeriksa kembali.",
          paid: "Pembayaran telah dikonfirmasi oleh server TutorLite.",
          paid_capacity_conflict:
            "Pembayaran diterima tetapi akses belum dapat diberikan. Dukungan akan menanganinya.",
          expired: "Sesi pembayaran berakhir tanpa konfirmasi pembayaran.",
          failed: "Checkout tidak berhasil. Kamu dapat mencoba lagi dengan aman.",
          cancelled: "Checkout dibatalkan sebelum pembayaran dikonfirmasi.",
        },
        guardianTitle: "Pembayaran untuk pelajar yang kamu wali",
        guardianBody:
          "Pembelian baru hanya akan diberikan kepada satu pelajar yang memenuhi syarat ini.",
        disabled: {
          billing_disabled:
            "Pembelian sedang dinonaktifkan. Kuota, riwayat, dan tanda terima tetap dapat dilihat.",
          account_restricted:
            "Akun ini dapat melihat pembayaran, tetapi tidak dapat membuat checkout baru.",
          capacity_unavailable:
            "Pass berikutnya sudah terjadwal. Pass tambahan belum dapat dibeli, tetapi paket interaksi tetap tersedia.",
          family_billing_not_supported:
            "Pembelian wali belum tersedia untuk akun dengan lebih dari satu pelajar yang memenuhi syarat. Riwayat milik pembayar tetap tersedia.",
          checkout_pending:
            "Selesaikan atau tunggu checkout yang sedang berjalan sebelum memulai yang baru.",
          status_unavailable:
            "Status kelayakan pembelian belum dapat diperiksa. Coba muat kembali bagian status.",
          loading: "Menunggu status kelayakan pembelian.",
          offer_not_available:
            "Pilihan ini tidak lagi tersedia. Pilih penawaran lain atau tunggu katalog dimuat ulang.",
        },
        offersTitle: "Pilihan prabayar",
        offersDescription: "Semua pembelian hanya sekali bayar dan tidak diperpanjang otomatis.",
        emptyTitle: "Belum ada pilihan prabayar",
        emptyBody:
          "Pass belajar dan paket interaksi belum tersedia untuk akun dan lokasimu saat ini.",
        passesTitle: "Pass belajar",
        passesDescription: "Akses berjangka dengan kuota interaksi yang diperbarui tiap bulan.",
        packsTitle: "Paket interaksi",
        packsDescription: "Tambahan interaksi sekali beli untuk digunakan sebelum kedaluwarsa.",
        prepaid: "Prabayar",
        passTerm: "Akses {{count}} bulan",
        monthlyInteractions: "{{formatted}} interaksi per bulan",
        monthlyReset: "Kuota pass diperbarui setiap bulan dan tidak diakumulasikan.",
        passExpiry: "Berakhir setelah masa {{count}} bulan.",
        packInteractions: "{{formatted}} interaksi",
        packExpiry: "Interaksi yang tidak digunakan kedaluwarsa {{count}} hari setelah pembelian.",
        noRenewal: "Sekali beli. Tidak diperpanjang otomatis.",
        buy: "Beli sekali",
        retryPurchase: "Coba checkout lagi",
        checkoutStarting: "Menyiapkan checkout…",
        checkoutError: {
          billing_disabled: "Pembelian sedang dinonaktifkan.",
          account_restricted: "Akun ini tidak diizinkan membuat checkout.",
          capacity_conflict: "Pass berikutnya sudah terisi. Paket interaksi masih dapat dibeli.",
          checkout_pending:
            "Checkout lain masih berjalan. Jangan membeli lagi atau memulai checkout baru.",
          family_billing_not_supported:
            "Checkout wali tidak mendukung lebih dari satu pelajar saat ini.",
          provider_redirect_unavailable:
            "Halaman pembayaran belum tersedia. Coba lagi dengan kunci checkout yang sama.",
          provider_terminal: "Sesi pembayaran tidak dapat dibuat untuk pilihan ini.",
          offer_not_available: "Pilihan ini tidak lagi tersedia. Muat ulang katalog.",
          rate_limited: "Terlalu banyak percobaan. Tunggu sebentar sebelum mencoba lagi.",
          retry_later:
            "TutorLite sedang memeriksa checkout yang mungkin sudah dibuat. Jangan membeli lagi atau memulai checkout baru.",
          idempotency_conflict:
            "Percobaan checkout ini tidak cocok dengan permintaan sebelumnya. Muat ulang halaman.",
          billing_configuration_unavailable: "Checkout sementara tidak tersedia.",
          default: "Checkout belum dapat dimulai. Coba lagi.",
        },
        historyTitle: "Riwayat pembayaran",
        historyDescription:
          "Pembelian milik akun pembayar, pengaruh, pengembalian dana, dan tanda terima.",
        historyEmptyTitle: "Belum ada pembayaran",
        historyEmptyBody: "Pembayaran satu kali akan muncul di sini setelah checkout dibuat.",
        moreHistory: "Tampilkan pembayaran sebelumnya",
        loadingMoreHistory: "Memuat pembayaran…",
        productType: { access_pass: "Pass belajar", credit_pack: "Paket interaksi" },
        paymentStatus: {
          pending: "Menunggu",
          paid: "Dibayar",
          partially_refunded: "Dikembalikan sebagian",
          refunded: "Dikembalikan",
          disputed: "Disengketakan",
          chargeback: "Chargeback",
          failed: "Gagal",
          expired: "Kedaluwarsa",
        },
        amount: "Jumlah",
        purchased: "Dibuat/dibayar",
        effect: "Nilai yang diberikan",
        effectType: {
          entitlement: "Pass belajar",
          credit_lot: "Lot kredit",
          unfulfilled: "Belum terpenuhi",
        },
        refunded: "Dikembalikan",
        refundStatus: {
          creating: "Menyiapkan pengembalian dana",
          provider_created: "Pengembalian dana dibuat",
          pending: "Pengembalian dana menunggu",
          succeeded: "Pengembalian dana selesai",
          failed: "Pengembalian dana gagal",
          cancelled: "Pengembalian dana dibatalkan",
        },
        receipt: "Buka tanda terima",
        refundSupport: "Minta bantuan pengembalian dana",
        refundSupportCreating: "Membuat permintaan…",
        refundSupportCreated: "Permintaan dukungan pengembalian dana dibuat.",
        refundSupportAlreadyOpen: "Permintaan dukungan yang masih terbuka ditemukan.",
        refundSupportExisting: "Permintaan dukungan tercatat pada {{date}}.",
        refundSupportError: "Permintaan dukungan belum dapat dibuat. Coba lagi.",
        availabilityDisclosure:
          "Harga dan ketersediaan diverifikasi kembali oleh server saat checkout. Dukungan pengembalian dana mengikuti kebijakan dan kelayakan pembayaran.",
      },
      feedback: {
        description: "Bagikan hal yang berjalan baik atau yang perlu diperbaiki.",
        formTitle: "Kirim masukan",
        formDescription: "Formulir teks ini dikirim langsung ke txtbag tanpa lampiran file.",
        thirdPartyDisclosure:
          "Saat kamu mengirim, browser meninggalkan TutorLite dan membuka halaman berhasil atau pengalihan dari txtbag. Kredensial sesi TutorLite tidak disertakan.",
        notConfigured:
          "Formulir masukan belum dikonfigurasi. Kamu tetap dapat meninjau templat lengkap di bawah.",
        category: "Kategori",
        categories: {
          general: "Umum",
          learning: "Pengalaman belajar",
          account: "Akun dan pembayaran",
          accessibility: "Aksesibilitas",
        },
        email: "Email (opsional)",
        emailPlaceholder: "nama@contoh.com",
        message: "Pesan",
        messagePlaceholder: "Ceritakan apa yang terjadi dan apa yang kamu harapkan.",
        privacy:
          "Jangan sertakan kata sandi, data pembayaran, jawaban belajar, atau informasi pribadi milik orang lain. Formulir ini hanya menerima teks; jangan kirim file atau tautan file pribadi.",
        send: "Kirim masukan",
        nativeDisclosure: "Pengiriman menggunakan halaman konfirmasi atau pengalihan txtbag.",
        disabledDisclosure: "Pengiriman dinonaktifkan sampai formulir dikonfigurasi.",
      },
      support: {
        description:
          "Hubungi dukungan operasional TutorLite untuk akun, pembayaran, privasi, atau masalah teknis.",
        newTitle: "Permintaan dukungan baru",
        newDescription:
          "Satu pesan per masalah. Jangan kirim kata sandi, token, atau detail kartu.",
        email: "Email",
        sendChallenge: "Kirim tautan verifikasi",
        sendingChallenge: "Mengirim…",
        challengeSent: "Jika email dapat menerima dukungan, tautan verifikasi telah dikirim.",
        challengeToken: "Token dari email",
        verifyChallenge: "Verifikasi email",
        verifying: "Memverifikasi…",
        verified: "Email terverifikasi untuk permintaan ini.",
        category: "Kategori",
        categories: {
          account_access: "Akses akun",
          billing: "Pembayaran",
          privacy: "Privasi",
          technical: "Teknis",
          other: "Lainnya",
        },
        subject: "Subjek",
        message: "Pesan",
        privacy:
          "Dukungan adalah kanal pihak pertama. Feedback tetap terpisah untuk masukan produk umum.",
        send: "Kirim permintaan dukungan",
        sending: "Mengirim…",
        created: "Permintaan dukungan dibuat.",
        error: "Permintaan belum dapat dikirim. Periksa isi pesan dan coba lagi.",
        myRequests: "Permintaanku",
        myRequestsDescription:
          "Termasuk permintaan bantuan pengembalian dana dari riwayat pembayaran.",
        loading: "Memuat dukungan…",
        noRequests: "Belum ada permintaan dukungan.",
        status: { open: "Terbuka", resolved: "Selesai", closed: "Ditutup" },
      },
      adminSupport: {
        title: "Dukungan admin",
        description: "Daftar, baca, selesaikan, atau tutup permintaan dukungan.",
        requests: "Permintaan",
        reason: "Alasan tindakan",
        resolve: "Selesaikan",
        close: "Tutup",
        spam: "Tandai spam",
      },
      events: {
        answer_evaluated: "Jawaban dinilai",
        question_asked: "Pertanyaan dibuat",
        practice_generated: "Latihan dibuat",
        recommendation_generated: "Rekomendasi diperbarui",
      },
      pathPage: {
        loading: "Memuat jalur belajar",
        eyebrow: "Jalur rekomendasi",
        description: "Urutan langkah yang disarankan berdasarkan kemajuanmu saat ini.",
        activeTitle: "Jalur aktif",
        version: "Versi jalur {{version}}",
        current: "Sekarang",
        upcoming: "Berikutnya",
        emptyTitle: "Belum ada jalur aktif",
        emptyBody:
          "Jalur akan muncul setelah TutorLite memiliki cukup bukti kemajuan untuk menyarankan langkah berikutnya.",
        emptyAction: "Lihat penguasaan",
      },
      pathActions: {
        practice: "Lanjutkan berlatih",
        learn: "Pelajari fondasi",
        review: "Tinjau kembali",
      },
      pathReasons: {
        continue_practice: "Terus kuatkan topik yang sedang dilatih.",
        build_foundation: "Bangun fondasi sebelum melanjutkan.",
      },
      analyticsPage: {
        loading: "Memuat analitik belajar",
        eyebrow: "Periode saat ini",
        description:
          "Ringkasan pribadi tanpa peringkat, perbandingan kelompok, atau perkiraan waktu belajar.",
        emptyTitle: "Belum ada analitik belajar",
        emptyBody:
          "Ringkasan akan muncul setelah ada kemajuan atau interaksi belajar pada periode ini.",
        emptyAction: "Buka jalur",
        periodTitle: "Aktivitas periode ini",
        periodDescription: "Hitungan penggunaan yang dicatat TutorLite, bukan durasi belajar.",
        interactions: "Interaksi terbaru",
        usage: "Penggunaan belajar",
        distributionTitle: "Sebaran penguasaan",
        distributionDescription: "Bagaimana topikmu tersebar di empat tahap belajar.",
        distributionLabel:
          "Belum dimulai {{unseen}}, belajar {{learning}}, berlatih {{practicing}}, dikuasai {{mastered}}",
        percentage: "{{value}}%",
      },
      masteryPage: {
        description: "Satu topik per baris agar keadaan dan kemajuan mudah dipindai.",
        emptyTitle: "Belum ada topik aktif",
        emptyBody: "Topik akan muncul setelah koleksi belajar aktif tersedia untuk profilmu.",
        emptyAction: "Lihat jalur",
      },
      difficulty: {
        easy: "Mudah",
        medium: "Sedang",
        hard: "Sulit",
      },
      onboarding: {
        loading: "Memuat penyiapan profil",
        title: "Siapkan profil belajarmu",
        ageBand: "Kelompok usia untuk profil belajarmu",
        ageBandPlaceholder: "Pilih kelompok usia",
        ageBandDescription:
          "Status wali terpisah dari profil belajar. Akses wali hanya dibuat setelah pelajar mengundang emailmu dan hubungan tersebut diverifikasi.",
        adult: "18 tahun atau lebih",
        minor: "Di bawah 18 tahun",
        accept: "Saya telah membaca dan menerima kebijakan versi {{version}}.",
        continue: "Lanjutkan",
        completeError: "Penyiapan belum dapat diselesaikan dengan versi kebijakan ini.",
        errors: {
          stale_terms:
            "Kebijakan berubah saat kamu meninjaunya. Tinjau versi terbaru lalu coba lagi.",
          policy_unavailable: "Kebijakan penyiapan sementara tidak tersedia. Coba lagi nanti.",
          terms_not_acceptable: "Kebijakan ini belum dibuka untuk penerimaan.",
          verified_email_required: "Verifikasi emailmu sebelum melanjutkan penyiapan.",
          invitation_required: "Akun ini memerlukan undangan pendaftaran yang masih berlaku.",
          approved_domain_required: "Email akun ini tidak memenuhi domain yang disetujui.",
          onboarding_conflict: "Status penyiapan berubah. Muat ulang halaman lalu coba lagi.",
          onboarding_failed: "Penyiapan belum dapat diselesaikan. Coba lagi.",
        },
        guardianTitle: "Hubungkan wali",
        guardianBody:
          "Wali menggunakan akun terpisah dan memilih setiap tujuan persetujuan sendiri.",
        guardianReviewTitle: "Minta peninjauan wali baru",
        guardianReviewBody:
          "Masukkan kembali email wali yang sama untuk mengirim tautan kebijakan dan persetujuan terbaru.",
        guardianEmail: "Email wali",
        send: "Kirim tautan wali",
        sending: "Mengirim…",
        guardianError: "Tautan wali belum dapat diminta. Coba lagi.",
        guardianPendingTitle: "Menunggu persetujuan wali",
        guardianPendingBody:
          "Tautan telah diminta. Wali harus masuk dengan akun terpisah dan meninjau kebijakan persetujuan.",
        guardianReplacementBody:
          "Tautan sebelumnya tidak lagi dapat digunakan? Masukkan email wali yang sama untuk menggantinya dengan tautan baru.",
        resend: "Kirim tautan pengganti",
        guardianSent: "Tautan wali baru telah diminta. Tautan sebelumnya tidak lagi berlaku.",
        guardianAccountTitle: "Siapkan akun wali",
        guardianAccountBody:
          "Tinjau ketentuan untuk menggunakan akun walimu. Langkah ini tidak mengaktifkan profil belajar untuk dirimu.",
        guardianAccountContinue: "Selesaikan penyiapan akun wali",
        guardianAccountUnavailable:
          "Penyiapan akun wali hanya tersedia setelah hubungan wali berhasil diverifikasi.",
        guardianAccountReadyTitle: "Akun wali siap",
        guardianAccountReadyBody:
          "Ketentuan akun saat ini sudah diterima. Kamu dapat melanjutkan ke Akun.",
        completeTitle: "Profil belajar siap",
        completeBody: "Profilmu telah menyelesaikan langkah penyiapan saat ini.",
        openHome: "Buka beranda",
      },
      guardian: {
        title: "Persetujuan wali",
        description:
          "Tinjau kebijakan lalu pilih setiap tujuan yang kamu setujui. Akses wali tidak pernah mencakup riwayat belajar tanpa batas.",
        loading: "Memuat kebijakan persetujuan wali",
        missingToken: "Tautan persetujuan tidak memiliki token yang diperlukan.",
        requiredTitle: "Diperlukan untuk mengaktifkan pembelajaran",
        requiredBody:
          "Jika salah satu tujuan ini tidak disetujui, persetujuan tetap dicatat tetapi pembelajaran tetap diblokir.",
        optionalTitle: "Pilihan tambahan",
        optionalBody: "Tujuan ini dapat dipilih secara terpisah.",
        record: "Catat persetujuan",
        verifyError: "Tautan tidak valid, kedaluwarsa, atau milik akun wali lain.",
        policyChanged: "Kebijakan berubah saat ditinjau. Muat ulang dan tinjau versi terbaru.",
        activeTitle: "Persetujuan aktif",
        activeBody: "Tujuan yang diperlukan telah disetujui dan pembelajaran dapat diaktifkan.",
        limitedTitle: "Persetujuan terbatas dicatat",
        limitedBody:
          "Satu atau beberapa tujuan yang diperlukan tidak disetujui, sehingga pembelajaran tetap diblokir.",
        openAccount: "Buka akun",
        continueAccountSetup: "Lanjutkan penyiapan akun wali",
        separateAccountTitle: "Gunakan akun wali terpisah",
        useAnotherAccount: "Keluar dan gunakan akun lain",
        linkProblemTitle: "Tautan wali tidak dapat digunakan",
        backToSignIn: "Kembali untuk masuk",
        errors: {
          guardian_identity_mismatch:
            "Kamu sedang masuk dengan akun yang berbeda dari wali yang diundang. Keluar lalu masuk atau buat akun dengan email wali yang menerima undangan.",
          fresh_session_required:
            "Tindakan ini memerlukan sesi wali yang baru. Keluar lalu masuk kembali dengan akun wali.",
          guardian_email_verification_required:
            "Akun wali harus memverifikasi email sebelum meninjau persetujuan.",
          guardian_challenge_expired:
            "Tautan wali telah kedaluwarsa. Minta pelajar mengirim tautan pengganti dari Penyiapan atau Akun.",
          guardian_challenge_consumed:
            "Tautan wali ini sudah digunakan atau telah diganti. Minta pelajar mengirim tautan baru jika persetujuan belum selesai.",
          guardian_challenge_locked:
            "Tautan wali dikunci setelah terlalu banyak percobaan dengan akun yang tidak cocok. Minta pelajar mengirim tautan pengganti.",
          guardian_relationship_revoked:
            "Hubungan wali ini telah dicabut. Pelajar harus memulai undangan wali baru.",
          invalid_guardian_challenge:
            "Tautan wali tidak valid. Buka tautan terbaru dari email atau minta pelajar mengirim pengganti.",
          guardian_review_failed: "Kebijakan wali belum dapat dimuat. Coba lagi.",
          guardian_verify_failed: "Persetujuan wali belum dapat dicatat. Coba lagi.",
        },
      },
      guardianPurposes: {
        progress: "Melacak kemajuan",
        content_practice: "Mengambil konten dan membuat latihan",
        cross_border: "Pemrosesan lintas batas",
        oauth_mcp: "Akses belajar melalui OAuth/MCP",
        recommendations: "Rekomendasi jalur belajar",
        guardian_summary: "Ringkasan terbatas untuk wali",
        aggregate_improvement: "Peningkatan produk secara agregat",
      },
      notFound: {
        title: "Halaman tidak ditemukan",
        body: "Alamat ini tidak mengarah ke halaman TutorLite yang tersedia.",
        action: "Kembali ke beranda",
      },
      auth: {
        loginTitle: "Masuk ke ruang belajarmu",
        email: "Email",
        password: "Kata sandi",
        signIn: "Masuk",
        signingIn: "Masuk…",
        loginInvalid: "Gagal masuk. Periksa email terverifikasi dan kata sandimu.",
        loginUnavailable: "Layanan masuk sementara tidak tersedia. Coba lagi.",
        createAccount: "Buat akun",
        forgotPassword: "Lupa kata sandi?",
        name: "Nama",
        registerTitle: "Buat akun belajar",
        creating: "Membuat…",
        registrationError: "Penyiapan akun belum dapat diselesaikan.",
        checkEmail: "Periksa emailmu",
        verificationSent: "Gunakan tautan verifikasi yang dikirim, lalu kembali untuk masuk.",
        backToSignIn: "Kembali untuk masuk",
        emailVerified: "Email terverifikasi",
        verifyEmail: "Verifikasi emailmu",
        verificationMissing: "Tautan verifikasi tidak memiliki token.",
        verifying: "Memverifikasi…",
        verificationInvalid: "Tautan verifikasi tidak valid atau kedaluwarsa.",
        continueSignIn: "Lanjutkan untuk masuk",
        forgotTitle: "Atur ulang kata sandi",
        resetSent: "Jika akun memenuhi syarat, tautan pengaturan ulang telah dikirim.",
        sending: "Mengirim…",
        sendReset: "Kirim tautan pengaturan ulang",
        passwordUpdated: "Kata sandi diperbarui",
        resetTitle: "Pilih kata sandi baru",
        resetMissing: "Tautan pengaturan ulang tidak memiliki token.",
        resetInvalid: "Tautan pengaturan ulang tidak valid atau kedaluwarsa.",
        newPassword: "Kata sandi baru",
        updatePassword: "Perbarui kata sandi",
      },
      consent: {
        title: "Izinkan akses pendamping",
        return: "{{client}} akan kembali ke {{host}}.",
        loading: "Memuat permintaan izin…",
        invalid: "Alur izin tidak valid atau kedaluwarsa.",
        allow: "Izinkan",
        allowing: "Mengizinkan…",
        deny: "Tolak",
        denying: "Menolak…",
        decisionError: "Permintaan izin belum dapat diselesaikan.",
      },
      overview: "Ringkasan",
      mastery: "Penguasaan",
      greeting: "Halo, {{name}}",
      heading: "Jejak belajarmu mulai terlihat.",
      intro: "Lihat topik yang baru dimulai, sedang dilatih, dan sudah dikuasai.",
      continue: "Lanjutkan ke penguasaan",
      signOut: "Keluar",
      retry: "Coba lagi",
      loading: "Menyiapkan ruang belajarmu",
      noTopics: "Belum ada topik aktif untuk dipelajari.",
      blocked: "Akses belajar belum aktif",
      blockedBody: "Selesaikan pendaftaran atau persetujuan wali sebelum membuka materi belajar.",
      unseen: "Belum dimulai",
      learning: "Belajar",
      practicing: "Berlatih",
      mastered: "Dikuasai",
      evidence: "{{count}} bukti belajar",
      lastUpdated: "Diperbarui {{date}}",
      neverUpdated: "Belum ada aktivitas",
      language: "Bahasa",
      account: "Akun",
      connectedClients: "Aplikasi terhubung",
      noClients: "Belum ada aplikasi MCP yang terhubung.",
      revoke: "Cabut akses",
      accountDetail: "Identitas dan akses pendampingmu.",
      path: "Jalur",
      activity: "Aktivitas",
      analytics: "Analitik",
      more: "Lainnya",
      moreNavigation: "Navigasi lainnya",
      progressSummary: "Ringkasan kemajuan belajar",
      trailMap: "Peta kemajuan",
      trailHint: "Empat tahap, satu perjalanan yang terus bergerak.",
      nextUp: "Berikutnya",
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        mastery: "Mastery",
        path: "Path",
        account: "Account",
        billing: "Billing",
        support: "Support",
        feedback: "Feedback",
        analytics: "Analytics",
        more: "More",
      },
      a11y: {
        skipToContent: "Skip to content",
        homeLabel: "TutorLite home",
        guardianAccountHome: "TutorLite guardian account home",
        primaryNavigation: "Primary navigation",
        learningNavigation: "Learning navigation",
        accountNavigation: "Account navigation",
        openAccountMenu: "Open account menu for {{name}}",
      },
      states: {
        loading: "Loading page",
        errorTitle: "Data could not be loaded",
        errorBody: "Try again. If the problem continues, return in a little while.",
      },
      accountUtility: {
        loadingSession: "Checking your account session",
      },
      access: {
        account_restricted: {
          title: "Learning access is restricted",
          body: "Open Account to review the security and access actions that remain available.",
          action: "Open account",
        },
        enrollment_required: {
          title: "Complete your learning profile",
          body: "Review the policy and finish enrollment before opening learning material.",
          action: "Continue setup",
        },
        guardian_required: {
          title: "Guardian consent is required",
          body: "Learning will open after your guardian reviews and grants the required consent.",
          action: "View account status",
        },
        terms_acceptance_required: {
          title: "Review the latest terms",
          body: "Accept the current terms before continuing learning activity.",
          action: "Review terms",
        },
        progress_disabled: {
          title: "Progress is unavailable",
          body: "Progress tracking is not currently available for this account.",
        },
        recommendations_disabled: {
          title: "Recommendations are unavailable",
          body: "Recommended paths are not currently available for this account.",
        },
      },
      common: {
        active: "Active",
        available: "Available",
        notRequired: "Not required",
        pending: "Pending",
        save: "Save changes",
        saving: "Saving…",
        unavailable: "Unavailable",
      },
      accountSections: {
        profile: "Profile",
        enrollment: "Enrollment",
        language: "Language",
        languageDescription: "Choose the TutorLite interface language.",
        languageHint: "The language changes only after you save.",
        languageSaved: "Language saved.",
        languageError: "The language could not be saved. Try again.",
        clientsDescription: "Companion applications that can access your account.",
        revokeError: "App access could not be revoked. Try again.",
        moreClients: "Show more applications",
        loadingMoreClients: "Loading applications…",
        session: "Session",
        sessionDescription: "Sign out of TutorLite on this device.",
        signingOut: "Signing out…",
        signOutError: "Could not sign out. Try again.",
        guardianSection: "Guardian and consent",
        guardianDescription:
          "Guardian relationships, consent purposes, and permitted limited summaries.",
        noGuardian: "There is no guardian relationship for this account yet.",
        guardianRevokeError: "The consent purpose could not be revoked. Try again.",
        revokePurpose: "Revoke",
        loginMethods: "Login methods",
        loginMethodsDescription: "Sign-in methods that can open this TutorLite account.",
        noLoginMethods: "No login methods can be shown yet.",
        providerKind: { password: "Password", oauth: "OAuth" },
        lastLoginMethod: "last method",
        unlinkProvider: "Unlink",
        linkProvider: "Link {{provider}}",
        providerLinkStarting: "Opening Google…",
        providerLinkPending: "{{provider}} linking is still pending.",
        providerLinkSupport: "Get support for attempt {{attemptId}}",
        providerLinkLearningWarning: "Learning history from another account is not transferred.",
        providerLinkBillingWarning: "Billing history and paid value are not transferred.",
        providerLinkError: "The login method could not be linked. Try again.",
        providerUnlinkError: "The login method could not be unlinked. Try again.",
        providerLinkStatus: {
          pending: "Linking is still pending.",
          confirmed: "Login method linked.",
          rejected: "Linking was rejected.",
          manual_support_required: "This link attempt needs support review.",
          expired: "The link attempt expired.",
        },
        summaryError: "The guardian summary could not be loaded.",
        summaryInteractions: "Interactions this period",
        summaryNextTopic: "Next topic",
        summaryLastActivity: "Last activity",
        guardianRole: { learner: "Learner profile", guardian: "Guardian profile" },
        guardianStatus: { invited: "Invitation sent", verified: "Verified", revoked: "Revoked" },
        consentStatus: { active: "Active", superseded: "Review required", revoked: "Revoked" },
        requestGuardianReview: "Request another review",
        optionalLearnerTitle: "Learn with this account",
        optionalLearnerDescription:
          "Optional: activate your own learning profile. This remains separate from learners you guard.",
        optionalLearnerAction: "Set up my learning profile",
        exportTitle: "Account export",
        exportDescription:
          "Download account data as NDJSON. Secrets, tokens, provider payloads, and other users' data are excluded.",
        exportIdle: "Export requires a recent sign-in and is created directly as it downloads.",
        exportPreparing: "Preparing export…",
        exportProgress: "Downloading {{bytes}} bytes…",
        exportSuccess: "Export is ready to download ({{bytes}} bytes).",
        exportAborted: "Export cancelled.",
        exportFreshRequired: "Sign in again, then retry the export.",
        exportError: "The export could not be created. Try again.",
        exportAction: "Download account export",
        exportAbort: "Cancel export",
        deleteTitle: "Delete account",
        deleteDescription:
          "Review your export first. A request disables learning access and MCP grants immediately, then enters a 7-day cooling-off period.",
        deleteValueFacts:
          "Active/scheduled value: {{passes}} passes, {{credits}} credits remaining.",
        deleteNoBlockers: "No execution blockers are visible for this account.",
        deleteStatus: "Deletion status: {{status}}.",
        deleteNoRestorePromise:
          "Cancellation does not restore sessions, MCP grants, deleted data, or extend entitlement time.",
        deleteCancel: "Cancel deletion request",
        deleteCancelling: "Cancelling…",
        deleteCancelError: "The deletion request could not be cancelled.",
        deleteValueDisposition: "Remaining paid-value decision",
        deleteDispositionPlaceholder: "Choose when value remains",
        deleteDispositionHint:
          "Required when the preview shows remaining passes or credits. Refund review and forfeiture are staging technical defaults.",
        deleteRefundReview: "Request refund review",
        deleteForfeit: "Continue without using remaining value",
        deleteAcknowledge:
          "I have considered exporting first and understand product access is disabled immediately.",
        deleteTyped: "Type DELETE to confirm",
        deleteTypedHint: "Use uppercase: DELETE.",
        deleteRequest: "Request account deletion",
        deleteRequesting: "Requesting…",
        deleteRequested:
          "Request accepted. Sessions and grants are not promised to return automatically if cancelled.",
        deleteErrors: {
          stale_preview: "The preview changed. Refresh the preview and try again.",
          fresh_session_required: "Sign in again, then retry.",
          request_blocked: "The request cannot be accepted because preview blockers remain.",
          executor_not_ready: "The deletion executor is not ready for this account.",
          value_disposition_required: "Choose a remaining paid-value decision.",
          default: "The deletion request could not be created.",
        },
        deleteProofTitle: "Status access when sign-in fails",
        deleteProofDescription:
          "Use an email challenge to read status or cancel the matched request. The proof token is not placed in the URL.",
        deleteProofSend: "Send status challenge",
        deleteProofToken: "Challenge token",
        deleteProofVerify: "Verify challenge",
        deleteProofReady: "Status proof is ready for reading or cancellation.",
      },
      home: {
        recentEyebrow: "Activity",
        recentTitle: "Recent learning",
        recentLoading: "Loading recent activity",
        recentEmptyTitle: "No learning activity yet",
        recentEmptyBody: "Safe activity will appear after you learn through a TutorLite companion.",
        recentCardTitle: "Your latest journey",
        recentCardDescription: "Account activity without answers, searches, or private content.",
        loadingEarlier: "Loading earlier activity…",
        earlierError: "Earlier activity could not be loaded.",
        showEarlier: "Show earlier activity",
        summaryTitle: "This period at a glance",
        summaryDescription:
          "A compact count; Analytics contains the detailed mastery distribution.",
        noTopicsBody: "Topics and a next step will appear when your learning profile is ready.",
      },
      billing: {
        loading: "Loading billing",
        loadingStatus: "Loading quota and access",
        loadingCatalog: "Loading prepaid options",
        loadingHistory: "Loading payment history",
        description: "Manage your quota, prepaid access, credits, and payment history.",
        returnTitle: "Checking payment status",
        returnBody:
          "We are reading the latest status from TutorLite. A browser return to this page does not mean the payment succeeded.",
        usageTitle: "Access and usage",
        usageDescription: "Your current allowance and prepaid value that remains available.",
        freeQuota: "Free quota remaining",
        currentUsage: "Current period remaining",
        quotaUsed: "{{used}} of {{limit}} used",
        usageProgress: "{{used}} of {{limit}} interactions used",
        usageSource: "Source: {{source}}",
        source: { free: "free quota", entitlement: "active pass" },
        entitlement: {
          active: "Active pass",
          scheduled: "Scheduled pass",
          activeEmpty: "There is no active pass yet.",
          scheduledEmpty: "There is no next pass scheduled.",
        },
        noPass: "None",
        term: "Term",
        monthlyQuota: "Monthly quota",
        creditsTitle: "Credit lots",
        creditsDescription: "Each lot is used according to its own expiry date.",
        creditRemaining: "of {{original}} original interactions",
        expires: "Expires {{date}}",
        creditsEmpty: "No prepaid credits remain.",
        latestCheckout: "Latest checkout",
        checkoutExpires: "Session expires {{date}}",
        resumeCheckout: "Continue checkout",
        checkoutStatus: {
          creating: "Creating checkout",
          reconciling: "Reconciling status",
          provider_created: "Ready for payment",
          pending: "Payment pending",
          paid: "Paid",
          paid_capacity_conflict: "Paid, support required",
          expired: "Expired",
          failed: "Failed",
          cancelled: "Cancelled",
        },
        checkoutStatusBody: {
          creating: "TutorLite is preparing the payment session.",
          reconciling: "The checkout status is being reconciled. Do not create another payment.",
          provider_created: "A payment session exists but has not been confirmed as paid.",
          pending: "Payment is not confirmed yet. This page will check again.",
          paid: "Payment has been confirmed by the TutorLite server.",
          paid_capacity_conflict:
            "Payment arrived but access could not be granted. Support will handle it.",
          expired: "The payment session expired without confirmed payment.",
          failed: "Checkout did not complete. You can retry safely.",
          cancelled: "Checkout was cancelled before payment was confirmed.",
        },
        guardianTitle: "Paying for your eligible learner",
        guardianBody: "A new purchase will benefit only this one eligible learner.",
        disabled: {
          billing_disabled:
            "Purchases are currently disabled. Quota, history, and receipts remain available.",
          account_restricted:
            "This account can read billing information but cannot create a new checkout.",
          capacity_unavailable:
            "A next pass is already scheduled. Another pass cannot be purchased, but interaction packs remain available.",
          family_billing_not_supported:
            "Guardian purchasing is not available for accounts with multiple eligible learners. Payer-owned history remains available.",
          checkout_pending:
            "Finish or wait for the checkout already in progress before starting another.",
          status_unavailable:
            "Purchase eligibility could not be checked. Retry the status section.",
          loading: "Waiting for purchase eligibility status.",
          offer_not_available:
            "This option is no longer available. Choose another offer or wait for the catalog to reload.",
        },
        offersTitle: "Prepaid options",
        offersDescription: "Every purchase is one-time and does not renew automatically.",
        emptyTitle: "No prepaid options are available yet",
        emptyBody:
          "Learning passes and interaction packs are not currently available for your account and location.",
        passesTitle: "Learning passes",
        passesDescription:
          "Fixed-term access with an interaction allowance that resets each month.",
        packsTitle: "Interaction packs",
        packsDescription: "One-time extra interactions to use before they expire.",
        prepaid: "Prepaid",
        passTerm: "{{count}}-month access",
        monthlyInteractions: "{{formatted}} interactions each month",
        monthlyReset: "The pass quota resets each month and does not roll over.",
        passExpiry: "Expires at the end of the {{count}}-month term.",
        packInteractions: "{{formatted}} interactions",
        packExpiry: "Unused interactions expire {{count}} days after purchase.",
        noRenewal: "One-time purchase. No automatic renewal.",
        buy: "Buy once",
        retryPurchase: "Retry checkout",
        checkoutStarting: "Starting checkout…",
        checkoutError: {
          billing_disabled: "Purchases are currently disabled.",
          account_restricted: "This account cannot create a checkout.",
          capacity_conflict: "The next pass slot is full. Interaction packs remain available.",
          checkout_pending:
            "Another checkout is still in progress. Do not repurchase or start a new checkout.",
          family_billing_not_supported: "Guardian checkout does not support multiple learners yet.",
          provider_redirect_unavailable:
            "The payment page is not available yet. Retry with the same checkout key.",
          provider_terminal: "A payment session cannot be created for this option.",
          offer_not_available: "This option is no longer available. Reload the catalog.",
          rate_limited: "There were too many attempts. Wait before trying again.",
          retry_later:
            "TutorLite is checking a checkout that may already exist. Do not repurchase or start another checkout.",
          idempotency_conflict:
            "This checkout attempt differs from its earlier request. Reload the page.",
          billing_configuration_unavailable: "Checkout is temporarily unavailable.",
          default: "Checkout could not be started. Try again.",
        },
        historyTitle: "Payment history",
        historyDescription: "Payer-owned purchases, effects, refunds, and receipts.",
        historyEmptyTitle: "No payments yet",
        historyEmptyBody: "One-time payments will appear here after a checkout is created.",
        moreHistory: "Show earlier payments",
        loadingMoreHistory: "Loading payments…",
        productType: { access_pass: "Learning pass", credit_pack: "Interaction pack" },
        paymentStatus: {
          pending: "Pending",
          paid: "Paid",
          partially_refunded: "Partially refunded",
          refunded: "Refunded",
          disputed: "Disputed",
          chargeback: "Chargeback",
          failed: "Failed",
          expired: "Expired",
        },
        amount: "Amount",
        purchased: "Created/paid",
        effect: "Granted value",
        effectType: {
          entitlement: "Learning pass",
          credit_lot: "Credit lot",
          unfulfilled: "Unfulfilled",
        },
        refunded: "Refunded",
        refundStatus: {
          creating: "Preparing refund",
          provider_created: "Refund created",
          pending: "Refund pending",
          succeeded: "Refund completed",
          failed: "Refund failed",
          cancelled: "Refund cancelled",
        },
        receipt: "Open receipt",
        refundSupport: "Request refund support",
        refundSupportCreating: "Creating request…",
        refundSupportCreated: "A refund-support request was created.",
        refundSupportAlreadyOpen: "Your existing open support request was found.",
        refundSupportExisting: "Support request recorded on {{date}}.",
        refundSupportError: "The support request could not be created. Try again.",
        availabilityDisclosure:
          "Price and availability are checked again by the server at checkout. Refund support follows payment eligibility and policy.",
      },
      feedback: {
        description: "Tell us what is working and what could be better.",
        formTitle: "Send feedback",
        formDescription: "This text-only form submits directly to txtbag without file attachments.",
        thirdPartyDisclosure:
          "When you submit, your browser leaves TutorLite and opens txtbag's success page or configured redirect. TutorLite session credentials are not included.",
        notConfigured:
          "The feedback form is not configured yet. You can still review the complete template below.",
        category: "Category",
        categories: {
          general: "General",
          learning: "Learning experience",
          account: "Account and billing",
          accessibility: "Accessibility",
        },
        email: "Email (optional)",
        emailPlaceholder: "name@example.com",
        message: "Message",
        messagePlaceholder: "Describe what happened and what you expected.",
        privacy:
          "Do not include passwords, payment details, learning answers, or another person's private information. This form accepts text only; do not send files or private file links.",
        send: "Send feedback",
        nativeDisclosure: "Submission uses txtbag's success page or configured redirect.",
        disabledDisclosure: "Submission is disabled until the form is configured.",
      },
      support: {
        description:
          "Contact first-party TutorLite support for account, billing, privacy, or technical problems.",
        newTitle: "New support request",
        newDescription: "One message per issue. Do not send passwords, tokens, or card details.",
        email: "Email",
        sendChallenge: "Send verification link",
        sendingChallenge: "Sending…",
        challengeSent: "If this email can receive support, a verification link was sent.",
        challengeToken: "Token from email",
        verifyChallenge: "Verify email",
        verifying: "Verifying…",
        verified: "Email verified for this request.",
        category: "Category",
        categories: {
          account_access: "Account access",
          billing: "Billing",
          privacy: "Privacy",
          technical: "Technical",
          other: "Other",
        },
        subject: "Subject",
        message: "Message",
        privacy:
          "Support is first-party operational help. Feedback remains separate product input.",
        send: "Send support request",
        sending: "Sending…",
        created: "Support request created.",
        error: "The request could not be sent. Check the message and try again.",
        myRequests: "My requests",
        myRequestsDescription: "Includes refund-support requests from payment history.",
        loading: "Loading support…",
        noRequests: "No support requests yet.",
        status: { open: "Open", resolved: "Resolved", closed: "Closed" },
      },
      adminSupport: {
        title: "Admin support",
        description: "List, read, resolve, or close support requests.",
        requests: "Requests",
        reason: "Action reason",
        resolve: "Resolve",
        close: "Close",
        spam: "Mark spam",
      },
      events: {
        answer_evaluated: "Answer evaluated",
        question_asked: "Question created",
        practice_generated: "Practice created",
        recommendation_generated: "Recommendation updated",
      },
      pathPage: {
        loading: "Loading learning path",
        eyebrow: "Recommended path",
        description: "An ordered set of suggested steps based on your current progress.",
        activeTitle: "Active path",
        version: "Path version {{version}}",
        current: "Current",
        upcoming: "Upcoming",
        emptyTitle: "No active path yet",
        emptyBody:
          "A path appears after TutorLite has enough progress evidence to suggest a useful next step.",
        emptyAction: "View mastery",
      },
      pathActions: {
        practice: "Continue practicing",
        learn: "Learn the foundation",
        review: "Review again",
      },
      pathReasons: {
        continue_practice: "Keep strengthening a topic already in practice.",
        build_foundation: "Build the foundation before moving forward.",
      },
      analyticsPage: {
        loading: "Loading learning analytics",
        eyebrow: "Current period",
        description:
          "A personal summary without rankings, cohort comparison, or inferred study time.",
        emptyTitle: "No learning analytics yet",
        emptyBody: "A summary appears after there is progress or learning activity in this period.",
        emptyAction: "Open path",
        periodTitle: "This period's activity",
        periodDescription: "TutorLite usage counts, not inferred learning duration.",
        interactions: "Recent interactions",
        usage: "Learning usage",
        distributionTitle: "Mastery distribution",
        distributionDescription: "How your topics are distributed across four learning stages.",
        distributionLabel:
          "Not started {{unseen}}, learning {{learning}}, practicing {{practicing}}, mastered {{mastered}}",
        percentage: "{{value}}%",
      },
      masteryPage: {
        description: "One topic per row so its state and progress are easy to scan.",
        emptyTitle: "No active topics yet",
        emptyBody:
          "Topics appear after an active learning collection is available to your profile.",
        emptyAction: "View path",
      },
      difficulty: {
        easy: "Easy",
        medium: "Medium",
        hard: "Hard",
      },
      onboarding: {
        loading: "Loading profile setup",
        title: "Set up your learning profile",
        ageBand: "Age group for your learning profile",
        ageBandPlaceholder: "Select an age group",
        ageBandDescription:
          "Guardian status is separate from your learning profile. Guardian access is created only after a learner invites your email and the relationship is verified.",
        adult: "18 or older",
        minor: "Under 18",
        accept: "I have read and accept policy version {{version}}.",
        continue: "Continue",
        completeError: "Setup could not be completed with this policy version.",
        errors: {
          stale_terms:
            "The policy changed while you reviewed it. Review the latest version and try again.",
          policy_unavailable: "The setup policy is temporarily unavailable. Try again later.",
          terms_not_acceptable: "This policy is not open for acceptance yet.",
          verified_email_required: "Verify your email before continuing setup.",
          invitation_required: "This account requires a valid enrollment invitation.",
          approved_domain_required: "This account email does not match an approved domain.",
          onboarding_conflict: "Your setup status changed. Reload the page and try again.",
          onboarding_failed: "Setup could not be completed. Try again.",
        },
        guardianTitle: "Connect a guardian",
        guardianBody:
          "A guardian uses a separate account and chooses each consent purpose independently.",
        guardianReviewTitle: "Request another guardian review",
        guardianReviewBody:
          "Enter the same guardian email again to send a link for the latest policy and consent choices.",
        guardianEmail: "Guardian email",
        send: "Send guardian link",
        sending: "Sending…",
        guardianError: "The guardian link could not be requested. Try again.",
        guardianPendingTitle: "Waiting for guardian consent",
        guardianPendingBody:
          "The link was requested. The guardian must sign in with a separate account and review the consent policy.",
        guardianReplacementBody:
          "Can the previous link no longer be used? Enter the same guardian email to replace it with a new link.",
        resend: "Send replacement link",
        guardianSent: "A new guardian link was requested. The previous link is no longer valid.",
        guardianAccountTitle: "Set up your guardian account",
        guardianAccountBody:
          "Review the terms for using your guardian account. This step does not activate a learning profile for you.",
        guardianAccountContinue: "Complete guardian account setup",
        guardianAccountUnavailable:
          "Guardian account setup is available only after the guardian relationship is verified.",
        guardianAccountReadyTitle: "Guardian account ready",
        guardianAccountReadyBody:
          "The current account terms are already accepted. You can continue to Account.",
        completeTitle: "Learning profile ready",
        completeBody: "Your profile has completed its current setup steps.",
        openHome: "Open Home",
      },
      guardian: {
        title: "Guardian consent",
        description:
          "Review the policy, then choose each purpose you agree to. Guardian access never includes unrestricted learning history.",
        loading: "Loading guardian consent policy",
        missingToken: "The consent link is missing its required token.",
        requiredTitle: "Required to activate learning",
        requiredBody:
          "If any of these purposes are declined, consent is still recorded but learning remains blocked.",
        optionalTitle: "Optional choices",
        optionalBody: "These purposes can be selected independently.",
        record: "Record consent",
        verifyError: "The link is invalid, expired, or belongs to another guardian account.",
        policyChanged: "The policy changed during review. Reload and review the latest version.",
        activeTitle: "Consent active",
        activeBody: "The required purposes were granted and learning can be activated.",
        limitedTitle: "Limited consent recorded",
        limitedBody: "One or more required purposes were declined, so learning remains blocked.",
        openAccount: "Open Account",
        continueAccountSetup: "Continue guardian account setup",
        separateAccountTitle: "Use a separate guardian account",
        useAnotherAccount: "Sign out and use another account",
        linkProblemTitle: "Guardian link cannot be used",
        backToSignIn: "Back to sign in",
        errors: {
          guardian_identity_mismatch:
            "You are signed in with a different account from the invited guardian. Sign out, then sign in or create an account with the guardian email that received the invitation.",
          fresh_session_required:
            "This action requires a fresh guardian session. Sign out and sign in again with the guardian account.",
          guardian_email_verification_required:
            "The guardian account must verify its email before reviewing consent.",
          guardian_challenge_expired:
            "This guardian link expired. Ask the learner to send a replacement from Setup or Account.",
          guardian_challenge_consumed:
            "This guardian link was already used or replaced. Ask the learner for a new link if consent is incomplete.",
          guardian_challenge_locked:
            "This guardian link was locked after too many attempts with a different account. Ask the learner to send a replacement.",
          guardian_relationship_revoked:
            "This guardian relationship was revoked. The learner must start a new guardian invitation.",
          invalid_guardian_challenge:
            "This guardian link is invalid. Open the newest email link or ask the learner for a replacement.",
          guardian_review_failed: "The guardian policy could not be loaded. Try again.",
          guardian_verify_failed: "Guardian consent could not be recorded. Try again.",
        },
      },
      guardianPurposes: {
        progress: "Track progress",
        content_practice: "Retrieve content and create practice",
        cross_border: "Cross-border processing",
        oauth_mcp: "OAuth/MCP learning access",
        recommendations: "Learning path recommendations",
        guardian_summary: "Limited guardian summary",
        aggregate_improvement: "Aggregate product improvement",
      },
      notFound: {
        title: "Page not found",
        body: "This address does not point to an available TutorLite page.",
        action: "Return Home",
      },
      auth: {
        loginTitle: "Sign in to your learning space",
        email: "Email",
        password: "Password",
        signIn: "Sign in",
        signingIn: "Signing in…",
        loginInvalid: "Sign-in failed. Check your verified email and password.",
        loginUnavailable: "Sign-in is temporarily unavailable. Try again.",
        createAccount: "Create account",
        forgotPassword: "Forgot password?",
        name: "Name",
        registerTitle: "Create your learning account",
        creating: "Creating…",
        registrationError: "Account setup could not be completed.",
        checkEmail: "Check your email",
        verificationSent: "Use the verification link we sent, then return to sign in.",
        backToSignIn: "Back to sign in",
        emailVerified: "Email verified",
        verifyEmail: "Verify your email",
        verificationMissing: "The verification link is missing its token.",
        verifying: "Verifying…",
        verificationInvalid: "This verification link is invalid or expired.",
        continueSignIn: "Continue to sign in",
        forgotTitle: "Reset your password",
        resetSent: "If the account is eligible, a reset link has been sent.",
        sending: "Sending…",
        sendReset: "Send reset link",
        passwordUpdated: "Password updated",
        resetTitle: "Choose a new password",
        resetMissing: "The reset link is missing its token.",
        resetInvalid: "This reset link is invalid or expired.",
        newPassword: "New password",
        updatePassword: "Update password",
      },
      consent: {
        title: "Authorize companion access",
        return: "{{client}} will return to {{host}}.",
        loading: "Loading authorization…",
        invalid: "The authorization flow is invalid or expired.",
        allow: "Allow",
        allowing: "Allowing…",
        deny: "Deny",
        denying: "Denying…",
        decisionError: "Authorization could not be completed.",
      },
      overview: "Overview",
      mastery: "Mastery",
      greeting: "Hello, {{name}}",
      heading: "Your learning trail is taking shape.",
      intro: "See what you have started, what needs practice, and what you have mastered.",
      continue: "Continue to mastery",
      signOut: "Sign out",
      retry: "Try again",
      loading: "Preparing your learning space",
      noTopics: "There are no active topics to learn yet.",
      blocked: "Learning access is not active",
      blockedBody: "Complete enrollment or guardian consent before opening learning material.",
      unseen: "Not started",
      learning: "Learning",
      practicing: "Practicing",
      mastered: "Mastered",
      evidence: "{{count}} learning evidence",
      lastUpdated: "Updated {{date}}",
      neverUpdated: "No activity yet",
      language: "Language",
      account: "Account",
      connectedClients: "Connected apps",
      noClients: "No MCP apps are connected yet.",
      revoke: "Revoke access",
      accountDetail: "Your identity and companion access.",
      path: "Path",
      activity: "Activity",
      analytics: "Analytics",
      more: "More",
      moreNavigation: "More navigation",
      progressSummary: "Learning progress summary",
      trailMap: "Progress map",
      trailHint: "Four stages, one journey that keeps moving.",
      nextUp: "Next up",
    },
  },
} as const

void i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("tl_locale") ?? (navigator.language.startsWith("en") ? "en" : "id"),
  fallbackLng: "id",
  interpolation: { escapeValue: false },
})
document.documentElement.lang = i18n.language.startsWith("en") ? "en" : "id"

export default i18n
